import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useVipMpSession } from '../../context/VipMpSessionContext';
import { VipMpHeader } from '../../shared/VipMpHeader';
export function PartnerLayout() {
  const session = useVipMpSession();
  const imsDisplayName = (() => {
    const user = session.adobeUser;
    if (!user) return '';

    const given = user.givenName?.trim() || '';
    const family = user.familyName?.trim() || '';
    const fullName = [given, family].filter(Boolean).join(' ').trim();
    const rawName = user.name?.trim() || '';

    if (rawName && rawName.toLowerCase() !== 'adobe user') return rawName;
    if (fullName) return fullName;
    if (rawName) return rawName;
    return '';
  })();

  const displayName = imsDisplayName || session.partnerContactName || 'Partner User';
  const displayEmail = session.adobeUser?.email || '';
  const initials = displayName
    .split(/\s+/)
    .map((s) => s[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <div id="partner-view" className="view active">
      <VipMpHeader
        initials={initials}
        userText={`${displayName}${displayEmail ? ` | ${displayEmail}` : ''}`}
        authSlot={
          <button type="button" className="btn btn-secondary btn-sm adobe-auth-logout" onClick={() => void session.logoutOfAdobe()}>
            Logout
          </button>
        }
      />

      <div className="nav-tabs">
        <NavLink
          to="/partner/submit"
          className={({ isActive }) => `nav-tab${isActive ? ' active' : ''}`}
          end
        >
          Submit New Request
        </NavLink>
        <NavLink to="/partner/submissions" className={({ isActive }) => `nav-tab${isActive ? ' active' : ''}`}>
          My Submissions
        </NavLink>
      </div>

      <div className="main-content">
        <Outlet />
      </div>
    </div>
  );
}
